import { LineString } from 'ol/geom';
import { BehaviorSubject } from 'rxjs';
import { AttrIndexService } from './attr-index.service';
import { MainDataService } from './main-data.service';
import { MapSharedService } from './map-shared.service';
import * as i0 from "@angular/core";
import * as i1 from "./attr-index.service";
import * as i2 from "./main-data.service";
import * as i3 from "./map-shared.service";
var EditSplitMergeService = /** @class */ (function () {
    function EditSplitMergeService(attrIndexService, mainDataService, mapSharedService) {
        this.attrIndexService = attrIndexService;
        this.mainDataService = mainDataService;
        this.mapSharedService = mapSharedService;
        this.splitLineBS = new BehaviorSubject(null);
        this.splitToolBS = new BehaviorSubject(null);
        this.mergeLineBS = new BehaviorSubject(null);
        this.mergeToolBS = new BehaviorSubject(null);
    }
    EditSplitMergeService.prototype.splitLineFeat = function (fallOnFeat, fallOnPoint) {
        var _this = this;
        var idCol = this.attrIndexService.rcUuidCol;
        var lineCoords = fallOnFeat.getGeometry().getCoordinates();
        var fallOnFeatAttrs = this.mainDataService.getDataAttrs(fallOnFeat.getId());
        var pos = this.mapSharedService.findCoordPositionOnLine(fallOnPoint, lineCoords);
        var partA = lineCoords.slice(0, pos[0] + 1);
        partA.push(fallOnPoint);
        var partB = lineCoords.slice(pos[1]);
        partB.unshift(fallOnPoint);
        // Create and add a new feat using partA
        var recPartA = this.mainDataService.addNewCard(idCol);
        var partAId = recPartA[idCol];
        Object.keys(fallOnFeatAttrs).forEach(function (key) {
            if (!recPartA.hasOwnProperty(key)) {
                // recPartA[key] = fallOnFeatAttrs[key];
                _this.mainDataService.setDataAttrs(partAId, key, fallOnFeatAttrs[key]);
            }
        });
        var featA = fallOnFeat.clone();
        featA.setId(partAId);
        featA.setGeometry(new LineString(partA));
        // Create and add a new feat using partB
        var recPartB = this.mainDataService.addNewCard(idCol);
        var partBId = recPartB[idCol];
        Object.keys(fallOnFeatAttrs).forEach(function (key) {
            if (!recPartB.hasOwnProperty(key)) {
                // recPartB[key] = fallOnFeatAttrs[key];
                _this.mainDataService.setDataAttrs(partBId, key, fallOnFeatAttrs[key]);
            }
        });
        // Add the original id before split
        this.mainDataService.setDataAttrs(partAId, this.attrIndexService.idBeforeSplitKey, fallOnFeat.getId());
        this.mainDataService.setDataAttrs(partBId, this.attrIndexService.idBeforeSplitKey, fallOnFeat.getId());
        var featB = fallOnFeat.clone();
        featB.setId(partBId);
        featB.setGeometry(new LineString(partB));
        return {
            featA: featA,
            featB: featB
        };
    };
    EditSplitMergeService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function EditSplitMergeService_Factory() { return new EditSplitMergeService(i0.ɵɵinject(i1.AttrIndexService), i0.ɵɵinject(i2.MainDataService), i0.ɵɵinject(i3.MapSharedService)); }, token: EditSplitMergeService, providedIn: "root" });
    return EditSplitMergeService;
}());
export { EditSplitMergeService };
